<div id="widgets-list"
     class="bg-very-light-gray padding-reset"
     style="height: 100vh">
  <div class="hds-panel">
    <div class="hds-panel-body">
      <div class="d-block">
        <div class="margin-v-s">
          <div class="grid-x padding-all">
            <div class="cell auto" style="padding-top: 1rem; padding-bottom: 1rem;">
              <h2>
                {{'widget.available-widget-title' | translate}}
              </h2>
            </div>
            <div class="cell shrink">
              <ng-select style="width: 150px; background-color: white"
                         (change)="onSelectedSolution($event)"
                         [items]="availableWidgetsApps"
                         [searchFn]="searchSolution"
                         placeholder="{{'widget.search' | translate}}">
                <ng-template ng-label-tmp let-item="item">
                  {{item | applicationName}}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{item | applicationName}}
                </ng-template>
              </ng-select>
            </div>
            <div mat-dialog-close="" id="close-widget-catalog"
                 class="close-button">
              <span aria-hidden="true">&times;</span>
            </div>
          </div>
          <div class="f-16 c-medium-gray padding-h-l">
            {{"widget.catalog.description" | translate }}
          </div>
        </div>

        <ng-container *ngIf="isCatalogLoaded; else noCatalog">
          <div style="overflow: auto" appAutoHeightElement>

            <div *ngFor="let availableWidget of filteredAvailableWidgets"
                 class="margin-v-s margin-all-l">

              <div class="d-block bg-white pos-relative padding-all"
                   style="border-radius:5px;">
                <div (click)="addWidget(availableWidget)" [id]="'optim-add-widget_'.concat(availableWidget.widgetName)"
                     class="button badge success border-all border-c-white z-depth-1 c-white position-absolute"
                     style="border-radius: 50%; border-width:3px; left: -8px; top: -8px; width:26px; height:26px; line-height:13px;">
                  <span class="fas fa-plus"></span></div>
                <div class="padding-h margin-b text-center">
                  <h5 class="font-500 margin-b-s">
                    {{"widget.name.".concat(availableWidget.widgetName) | translate }}
                  </h5>
                  <span class="f-10 c-medium-gray">
                    {{"widget.description.".concat(availableWidget.widgetName) | translate }}
                  </span>
                </div>
                <div class="d-block z-depth-1 margin-v-l"
                     style="border-radius:5px; pointer-events:none; height: fit-content;"
                     [ngStyle]="isOfSize(availableWidget, WidgetSize.SMALL) && {'margin-right': 'auto', 'margin-left': 'auto', 'width': '220px'}">
                  <app-widget *ngIf="isOfSize(availableWidget, WidgetSize.SMALL)"
                              [widget]="getMockedWidgetDetail(availableWidget, WidgetSize.SMALL)"
                              [isMocked]="true"
                              [dashboardId]="dashboardId">
                  </app-widget>
                  <app-widget *ngIf="isOfSize(availableWidget, WidgetSize.LARGE)"
                              [widget]="getMockedWidgetDetail(availableWidget, WidgetSize.LARGE)"
                              [isMocked]="true"
                              [dashboardId]="dashboardId">
                  </app-widget>
                  <app-widget *ngIf="isOfSize(availableWidget, WidgetSize.XLARGE) && {'height': 'fit-content'}"
                              [widget]="getMockedWidgetDetail(availableWidget, WidgetSize.XLARGE)"
                              [isMocked]="true"
                              [dashboardId]="dashboardId">
                  </app-widget>
                </div>
                <div class="d-block padding-h text-center">
                  <ng-container *ngFor="let availableSize of availableWidget.availableSizes">
                    <button [ngClass]="{'insito': isSizeSelected(availableWidget, availableSize),
                                    'hollow': !isSizeSelected(availableWidget, availableSize),
                                    'medium-gray': !isSizeSelected(availableWidget, availableSize)}"
                            (click)="selectSize(availableWidget, availableSize)"
                            [id]="'optim-chose-size-widget_'.concat(availableWidget.widgetName).concat('_').concat(availableSize)"
                            class="button border-radius-default small padding-h-l padding-v-s margin-h-xs">
                      {{"widget.size.".concat(availableSize) | translate}}
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>

          </div>
        </ng-container>
        <ng-template #noCatalog>
          <div class="widget-spinner">
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

